import { render, staticRenderFns } from "./SCenter.vue?vue&type=template&id=3f2ddd44"
import script from "./SCenter.vue?vue&type=script&lang=js"
export * from "./SCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports